class CorrelationStackLineupAnalyzer {
    constructor(players) {
        this.players = players;
        this.stackedPlayerIds = [];
    }

    analyze(lineup, params) {
        const {teamName, isGameStack, onlyPositions} = params;

        this.stackedPlayerIds = [];

        lineup.getPlayerIds().map((id) => {
            const player = this.players.getPlayer(id);
            const positionNames = player.positionName.split('/');

            if (!arrayDuplicates(positionNames, onlyPositions)) {
                return;
            }

            if (teamName === player.team) {
                this.stackedPlayerIds.push(String(id));
            } else if (teamName === player.opponent && isGameStack) {
                this.stackedPlayerIds.push(String(id));
            }
        });
    }

    getStackedPlayerIds() {
        return this.stackedPlayerIds;
    }
}

export default CorrelationStackLineupAnalyzer;
